<div class="bg-background text-on-background min-h-screen flex flex-col items-center justify-center px-4 py-12 relative overflow-hidden">
  <div class="absolute top-0 left-0 w-full h-full pointer-events-none opacity-20">
    <div class="absolute top-[-10%] right-[-10%] w-[600px] h-[600px] rounded-full bg-primary-container/20 blur-[120px]"></div>
    <div class="absolute bottom-[-10%] left-[-10%] w-[600px] h-[600px] rounded-full bg-secondary-container/20 blur-[120px]"></div>
  </div>
  <div class="mb-12 relative z-10">
    <a routerLink="/" class="text-3xl font-extrabold tracking-tight text-primary">ZAD ERP</a>
  </div>
  <div class="w-full max-w-lg bg-surface-container-lowest rounded-xl p-8 md:p-12 ambient-shadow relative z-10">
    <div class="absolute top-6 right-8 flex items-center gap-4">
      <a routerLink="/" class="text-sm font-medium text-on-surface-variant hover:text-primary transition-colors">Home</a>
      <span class="w-1 h-1 bg-outline-variant rounded-full"></span>
      <a class="text-sm font-semibold text-primary" href="#">عربي</a>
    </div>
    <div class="mt-8 text-center">
      <h1 class="text-2xl md:text-3xl font-bold text-on-surface tracking-tight mb-4">Create a new password</h1>
      <p class="text-on-surface-variant leading-relaxed mb-10 max-w-sm mx-auto">
        Please enter a new, strong password below.
      </p>
    </div>
    <form (submit)="onSubmit($event)" class="space-y-6">
      <div class="space-y-2">
        <label class="block text-xs font-bold uppercase tracking-wider text-on-surface-variant px-1" for="new-password">
          New Password *
        </label>
        <div class="relative group">
          <div class="absolute inset-y-0 left-4 flex items-center pointer-events-none text-outline">
            <span class="material-symbols-outlined text-[20px]">lock</span>
          </div>
          <input class="w-full pl-12 pr-12 py-4 bg-surface-container-low border-0 rounded-xl focus:ring-0 focus:outline-none placeholder:text-outline transition-all focus:bg-surface-container-lowest ring-2 ring-transparent focus:ring-surface-tint/40" id="new-password" name="password" placeholder="Min. 8 characters" required [type]="passwordVisible ? 'text' : 'password'" />
          <div class="absolute inset-y-0 right-4 flex items-center cursor-pointer text-outline hover:text-primary transition-colors" (click)="togglePasswordVisibility()">
            <span class="material-symbols-outlined text-[20px]">{{passwordVisible ? 'visibility_off' : 'visibility'}}</span>
          </div>
        </div>
      </div>
      <div class="space-y-2">
        <label class="block text-xs font-bold uppercase tracking-wider text-on-surface-variant px-1" for="confirm-password">
          Confirm New Password *
        </label>
        <div class="relative group">
          <div class="absolute inset-y-0 left-4 flex items-center pointer-events-none text-outline">
            <span class="material-symbols-outlined text-[20px]">lock_clock</span>
          </div>
          <input class="w-full pl-12 pr-12 py-4 bg-surface-container-low border-0 rounded-xl focus:ring-0 focus:outline-none placeholder:text-outline transition-all focus:bg-surface-container-lowest ring-2 ring-transparent focus:ring-surface-tint/40" id="confirm-password" name="confirm_password" placeholder="Re-enter password" required [type]="confirmPasswordVisible ? 'text' : 'password'" />
          <div class="absolute inset-y-0 right-4 flex items-center cursor-pointer text-outline hover:text-primary transition-colors" (click)="toggleConfirmPasswordVisibility()">
            <span class="material-symbols-outlined text-[20px]">{{confirmPasswordVisible ? 'visibility_off' : 'visibility'}}</span>
          </div>
        </div>
      </div>
      <div class="pt-4">
        <button class="w-full py-4 px-6 bg-gradient-to-r from-primary to-primary-container text-on-primary font-bold rounded-xl ambient-shadow hover:scale-[1.02] active:scale-[0.98] transition-all flex items-center justify-center gap-2 group" type="submit">
          <span>Update Password</span>
          <span class="material-symbols-outlined text-[20px] group-hover:translate-x-1 transition-transform">check_circle</span>
        </button>
      </div>
    </form>
  </div>
  <div class="mt-12 text-center flex items-center justify-center gap-2 text-xs uppercase tracking-[0.2em] text-on-surface-variant font-medium opacity-60">
    <span class="material-symbols-outlined text-[16px]">lock</span>
    <span>Secure end-to-end encryption</span>
  </div>
</div>
